import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=4dcd4947&scoped=true"
var script = {}
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=4dcd4947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd4947",
  null
  
)

export default component.exports